import { render, staticRenderFns } from "./ArticleTitle.vue?vue&type=template&id=05fbe1a4&scoped=true"
import script from "./ArticleTitle.vue?vue&type=script&lang=js"
export * from "./ArticleTitle.vue?vue&type=script&lang=js"
import style0 from "./ArticleTitle.vue?vue&type=style&index=0&id=05fbe1a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fbe1a4",
  null
  
)

export default component.exports